import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import atoms from 'ctsutheme/components/atoms';
import { BoolToString, GetEmptyValue } from 'components';
import molecules from 'ctsutheme/components/molecules';
import PropTypes from 'prop-types';
import { TE } from 'appconstants';

const { List, ListSubHeader } = molecules;
const { Typography, Divider } = atoms;

const ViewIntegrationInfo = props => {
  const { intInfo } = props;
  return (
    <>
      <FormViewContent
        primaryText="LPO Supplemental Documents Posted?"
        name="isCtsuMenu"
        secondaryText={<BoolToString boolValue={intInfo.isCtsuMenu} />}
      />
      <Divider />
      <FormViewContent
        primaryText="Website Activation Date"
        name="ctsuMenuDate"
        secondaryText={<GetEmptyValue value={intInfo.ctsuMenuDate} />}
      />
      <Divider />
      <FormViewContent
        primaryText="TRIAD Protocol?"
        name="isTriadProt"
        secondaryText={<BoolToString boolValue={intInfo.isTriadProt} />}
      />
      <Divider />
      <FormViewContent
        primaryText="TRIAD Activation Date"
        name="triadActivationDate"
        secondaryText={<GetEmptyValue value={intInfo.triadActivationDate} />}
      />
      <Divider />
      <FormViewContent
        primaryText="RT QA Flag?"
        name="isRtQaStudy"
        secondaryText={<BoolToString boolValue={intInfo.isRtQaStudy} />}
      />
      <Divider />
      <FormViewContent
        primaryText="RT QA Activation Date"
        name="rtQaActivationDate"
        secondaryText={<GetEmptyValue value={intInfo.rtQaActivationDate} />}
      />
      <Divider />
      <FormViewContent
        primaryText="IROC Full Integration"
        name="isIrocFullIntegration"
        secondaryText={<BoolToString boolValue={intInfo.isIrocFullIntegration} />}
      />
      <Divider />
      <FormViewContent
        primaryText="DQP Supported?"
        name="isDqpSupported"
        secondaryText={<BoolToString boolValue={intInfo.isDqpSupported} />}
      />
      <Divider />
      <FormViewContent
        primaryText="Using TSDV?"
        name="isTsdv"
        secondaryText={<BoolToString boolValue={intInfo.isTsdv} />}
      />
      <Divider />
      <FormViewContent
        primaryText="E-Pro Study?"
        name="isEproStudy"
        secondaryText={<BoolToString boolValue={intInfo.isEproStudy} />}
      />
      <Divider />
      <FormViewContent
        primaryText="DCP001 Screening Log?"
        name="isScreeningLog"
        secondaryText={<BoolToString boolValue={intInfo.isScreeningLog} />}
      />
      <Divider />
      <FormViewContent
        primaryText="IRB Exempt?"
        name="isIrbExempt"
        secondaryText={<BoolToString boolValue={intInfo.isIrbExempt} />}
      />
      <Divider />
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id={`${TE.ID}central_monitor${TE.LBL}`} inline primary>
            Central Monitoring
            </Typography>
          </ListSubHeader>
        )}
      >
        <FormViewContent
          primaryText="Central Monitoring?"
          name="isCentralMonitoring"
          secondaryText={<BoolToString boolValue={intInfo.isCentralMonitoring} />}
        />
        <Divider />
        <FormViewContent
          primaryText="CM Effective Date"
          name="cmEffectiveDate"
          secondaryText={<GetEmptyValue value={intInfo.cmEffectiveDate} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Selection Method"
          name="cmPatientSelectionMethod"
          secondaryText={<GetEmptyValue value={intInfo.cmPatientSelectionMethod} />}
        />
        <FormViewContent
          primaryText="Patient First X"
          name="cmFirstXPatient"
          secondaryText={<GetEmptyValue value={intInfo.cmFirstXPatient} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Next Y"
          name="cmNextYPatient"
          secondaryText={<GetEmptyValue value={intInfo.cmNextYPatient} />}
        />
      </List>
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id={`${TE.ID}eligibility_review${TE.LBL}`} inline primary>
            Eligibility Review
            </Typography>
          </ListSubHeader>
        )}
      >
        <FormViewContent
          primaryText="Eligibility Review?"
          name="isSupportEligibilityReview"
          secondaryText={<BoolToString boolValue={intInfo.isSupportEligibilityReview} />}
        />
        <Divider />
        <FormViewContent
          primaryText="ER Effective Date"
          name="erEffectiveDate"
          secondaryText={<GetEmptyValue value={intInfo.erEffectiveDate} />}
        />
        <Divider />
        <FormViewContent
          primaryText="ER Patient Select Effective Date"
          name="erPatientSelectEffectiveDate"
          secondaryText={<GetEmptyValue value={intInfo.erPatientSelectEffectiveDate} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Selection Method"
          name="erPatientSelectionMethod"
          secondaryText={<GetEmptyValue value={intInfo.erPatientSelectionMethod} />}
        />
        <FormViewContent
          primaryText="Patient First X"
          name="erFirstXPatients"
          secondaryText={<GetEmptyValue value={intInfo.erFirstXPatients} />}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Next Y"
          name="erNextYPatients"
          secondaryText={<GetEmptyValue value={intInfo.erNextYPatients} />}
        />
      </List>
    </>
  );
};

ViewIntegrationInfo.propTypes = {
  intInfo: PropTypes.oneOfType([PropTypes.object])
};

ViewIntegrationInfo.defaultProps = {
  intInfo: null
};

export default ViewIntegrationInfo;
